import { getApps, initializeApp } from 'firebase/app';
import {
  getToken as fetchFcmToken,
  getMessaging,
  onMessage,
  type MessagePayload,
} from 'firebase/messaging';
import { toApiTruthy } from 'helpers/functions/converter';
import { createNanoEvents } from 'nanoevents';
import { createDevice, updateDevice } from 'services/API/Device';
import { CreateDeviceResponse, DeviceProps } from 'services/API/Device/interface';
import UAparser from 'ua-parser-js';

interface Events {
  onNotification: (payload: any) => void;
}

const messageEmitter = createNanoEvents<Events>();

const onNotification = (cb: (payload: any) => void) => {
  return messageEmitter.on('onNotification', cb);
};
export default onNotification;

export const initFirebaseMessaging = async (): Promise<void> => {
  if (getApps().length > 0) {
    return;
  }

  try {
    const messaging = getFirebaseMessaging();
    const token = await getToken(messaging);
    await registerDevice(token);

    onMessage(messaging, (payload: MessagePayload) => {
      messageEmitter.emit('onNotification', payload);
    });
  } catch (e) {}

  return;
};

const getFirebaseMessaging = () => {
  const existing = getApps();
  const app = existing.length > 0 ? existing[0] : initializeApp((window as any).firebaseConfig);

  return getMessaging(app);
};

const getToken = async (messaging: ReturnType<typeof getMessaging>): Promise<string> => {
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Notification permission not granted');
  }

  return fetchFcmToken(messaging);
};

const registerDevice = async (token: string): Promise<CreateDeviceResponse> => {
  const parser = new UAparser();
  const browserVersion = parser.getBrowser().name + ' ' + parser.getBrowser().version;

  const deviceData: DeviceProps = {
    platform: 'web',
    token: token,
    provider: 'fcm',
    name: browserVersion.substr(0, 30),
    enabled: toApiTruthy(true),
  };

  let result = null;
  if (localStorage.device_id && localStorage.device_user_id === localStorage.current_user_id) {
    result = await updateDevice(localStorage.device_id, deviceData);
  } else {
    result = await createDevice(deviceData);
  }

  if (result.success) {
    localStorage.device_id = result.data.id;
    localStorage.device_user_id = localStorage.current_user_id;
    console.log('push notification register successful.');
  } else {
    console.error('push notification register unsuccessful.');
  }

  return result;
};
